exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".le-right-menu{position:absolute;background-color:#f9f9f9;z-index:1500;width:140px;border-radius:3px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2)}.le-right-menu>a{color:rgba(0,0,0,.65);padding:5px 16px;text-decoration:none;display:block;text-align:center;position:relative}.le-right-menu .dividing-line{border-bottom:1px solid #e2e2e2}.le-right-menu>a:hover,.le-right-menu>a>.img-menu>a:hover{background-color:#c7e3f1;border-radius:3px}.le-right-menu>a>.img-menu{background-color:#f9f9f9;width:140px;position:absolute;left:140px;top:0;border-radius:3px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2)}.le-right-menu>a>.img-menu>a{color:rgba(0,0,0,.65);padding:5px 16px;text-decoration:none;display:block;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/components/notes/menu.css
// module id = 71
// module chunks = 0